module.exports = __webpack_public_path__ + "static/assets/14c61fd8ad27bc29e8ad5aaba8bb38cd.gif";